import React from "react";
import { SITE, waUrl } from "@/lib/site";
import { MapPin, Phone, Mail, ArrowLeftRight } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#0A1128] text-white border-t border-[#C5A059]/20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <img
              src={SITE.media.logo}
              alt={`${SITE.brandName} logo`}
              className="h-16 w-16 object-contain"
            />
            <div className="flex flex-col">
              <span className="font-serif-display text-3xl tracking-tight">{SITE.brandName}</span>
              <span className="text-[10px] tracking-[0.25em] uppercase text-[#C5A059]">
                Tradutor Juramentado
              </span>
            </div>
          </div>
          <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-sm">
            {SITE.professionalName} — Tradutor e Intérprete Juramentado Espanhol{" "}
            <ArrowLeftRight size={13} className="inline align-middle mx-0.5 text-[#C5A059]" strokeWidth={1.75} />{" "}
            Português. Credenciado pela Justiça Federal e {SITE.matricula}.
          </p>
          <img
            src={SITE.media.seal}
            alt="Selo institucional"
            className="mt-6 w-20 opacity-60"
          />
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-5"><span className="gold-rule mr-3 align-middle" />Navegação</p>
          <ul className="space-y-3 text-sm">
            <li><a href="#sobre" className="hover:text-[#C5A059] transition-colors">Sobre</a></li>
            <li><a href="#credenciamentos" className="hover:text-[#C5A059] transition-colors">Credenciamentos</a></li>
            <li><a href="#servicos" className="hover:text-[#C5A059] transition-colors">Serviços</a></li>
            <li><a href="#processo" className="hover:text-[#C5A059] transition-colors">Processo</a></li>
            <li><a href="#valores" className="hover:text-[#C5A059] transition-colors">Valores</a></li>
            <li><a href="#contato" className="hover:text-[#C5A059] transition-colors">Contato</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline mb-5"><span className="gold-rule mr-3 align-middle" />Contato</p>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <Phone size={16} className="text-[#C5A059] mt-0.5" strokeWidth={1.5} />
              <a href={waUrl()} target="_blank" rel="noopener noreferrer" className="hover:text-[#C5A059] transition-colors">
                {SITE.whatsappDisplay}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="text-[#C5A059] mt-0.5" strokeWidth={1.5} />
              <a href={`mailto:${SITE.email}`} className="hover:text-[#C5A059] transition-colors break-all">
                {SITE.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-[#C5A059] mt-0.5" strokeWidth={1.5} />
              <span>{SITE.city}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} {SITE.brandName}. Todos os direitos reservados.</p>
          <p>Tradutor Juramentado · Validade jurídica nacional</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
